export default __webpack_public_path__ + "static/media/play_pepper_card.9f792609.png";